import { z } from 'zod';
// What can still use a reference value — a zone · a cluster · a site type · a
// priority · a category · a tag · a responsibility · an administrative area · a
// team (deleted only while empty and never used). A
// value is deleted only while NOTHING uses it, whatever the status of what uses
// it: a decommissioned site, a past classification period, a disabled cluster all
// count. The refusal is `409 REFERENCE_IN_USE` whose `details.uses` names each
// kind still in use with its count (a kind at zero is left out); the delete door
// reads them back ("Still in use — 12 sites and 2 responsibility chains.").
//   sites          — the sites carrying it (their cluster · type · priority · category · area · tags)
//   history        — the past classification periods carrying it (the current one is the site's own)
//   configurations — the contractual configurations pricing it
//   clusters       — the clusters inside a zone
//   areas          — the areas directly inside an area
//   grants         — the people whose scope names the zone or the cluster
//   chains         — the responsibility chains held at the zone or the cluster or the team, or of the responsibility (one per chain)
//   members        — the people on a team (a team deletes only while empty and never used — ADR-083 §8)
export const REFERENCE_USE_KINDS = ['sites', 'history', 'configurations', 'clusters', 'areas', 'grants', 'chains', 'members'];
export const ReferenceUseKindSchema = z.enum(REFERENCE_USE_KINDS);
/** `details.uses` of a `REFERENCE_IN_USE` refusal — each kind in use with its count. */
export const ReferenceUsesSchema = z.partialRecord(ReferenceUseKindSchema, z.number().int().positive());
